export default "__VITE_ASSET__CeLOJQb9__"